import { cn } from "@/lib/utils";
import { FULL_IMAGE_IN_SQUARE, usesFullPlayerImage } from "@repo/shared/utils";
import { useSelector } from "react-redux";

import { extractColors } from "../../../../functions/extractCardColors";
import { getVersionAssetsSelector } from "../../../../redux/loadedContent/loadedContentSlice";

type Props = {
  metalId: number;
  versionId: number;
  playerUrl: string;
  playerName?: string;
  isSelecting?: boolean;
  className?: string;
  hasDynamicImage?: boolean;
};

const fullImageStyle = {
  width: `${FULL_IMAGE_IN_SQUARE.width * 100}%`,
  left: `${FULL_IMAGE_IN_SQUARE.left * 100}%`,
  top: `${FULL_IMAGE_IN_SQUARE.top * 100}%`,
};

export const SquarePlayer = ({
  metalId,
  versionId,
  playerName,
  playerUrl,
  isSelecting,
  className,
  hasDynamicImage,
}: Props) => {
  const fullImage = usesFullPlayerImage(hasDynamicImage, versionId);
  const versionAssets = useSelector(getVersionAssetsSelector);
  const { cardUrl } = extractColors({
    versionAssets,
    versionId,
    metalId,
    isSquare: true,
  });

  return (
    <article
      className={cn(
        "relative w-9 h-9 mobile:w-14 mobile:h-14 overflow-hidden rounded shrink-0",
        className,
      )}
    >
      <img src={cardUrl} className="absolute" alt={playerName} />
      <img
        src={playerUrl + "?v5"}
        style={{
          background: isSelecting
            ? "linear-gradient(0deg, rgba(255, 255, 255, 0.30) 0%, rgba(255, 255, 255, 0.30) 100%)"
            : "none",
          ...(fullImage && fullImageStyle),
        }}
        className={cn("absolute", fullImage && "max-w-none")}
        alt={playerName}
      />
    </article>
  );
};
